import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export const PainPoints = () => {
  const pains = ['Sentís que tu estudio se estancó y necesitás innovar para atraer nuevas alumnas.', 'Querés sumar Barre pero las formaciones tradicionales son larguísimas y carísimas.', 'No sabés por dónde empezar: qué comprar, cómo armar la clase o qué música usar.', 'Te da miedo invertir en barras y equipos sin saber si va a ser rentable.', 'No tenés tiempo para planificar desde cero un servicio completamente nuevo.'];
  return <section className="py-20 bg-white" data-id="element-84">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-85">
        <div className="text-center mb-12" data-id="element-86">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-87">
            ¿Te sentís identificada con alguna de estas situaciones?
          </h2>
          <p className="text-lg text-gray-600" data-id="element-88">
            Sabemos lo difícil que es hacer crecer un estudio de pilates en
            Argentina hoy en día.
          </p>
        </div>

        <div className="space-y-4" data-id="element-89">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 p-6 bg-barre-blush rounded-2xl border border-barre-border" data-id="element-90">
              <XCircle className="w-6 h-6 text-barre-pink flex-shrink-0 mt-0.5" data-id="element-91" />
              <p className="text-gray-800 font-medium text-lg" data-id="element-92">{pain}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};